import React from 'react';

import { PageWrapper, OrderStatus } from '../components';


const OrderStatusPage = () => (
  <PageWrapper title="Check Order Status">
    <div className="contentPage">
      <div className="row">
        <div className="col-xs-12">

          <OrderStatus />

        </div>
      </div>
    </div>
  </PageWrapper>
);

export default OrderStatusPage;



// WEBPACK FOOTER //
// ./src/pages/order-status.js